// extracted by mini-css-extract-plugin
export default {"container":"wl-z","bubbleNav":"xl-z","graphic":"yl-z","contact":"zl-z"};